import { authFetch } from "@/lib/api-client";
import type {
  PublicApiTokenCreateBody,
  PublicApiTokenCreateResponse,
  PublicApiTokenListItem,
  PublicApiTokenUpdateBody,
} from "@nexus/contracts";

export async function fetchPublicApiTokens(): Promise<PublicApiTokenListItem[]> {
  const { data } = await authFetch<{ items: PublicApiTokenListItem[] }>("/api-tokens");
  return data.items;
}

export async function createPublicApiToken(
  body: PublicApiTokenCreateBody,
): Promise<PublicApiTokenCreateResponse> {
  const { data } = await authFetch<PublicApiTokenCreateResponse>("/api-tokens", {
    method: "POST",
    body: JSON.stringify(body),
  });
  return data;
}

export async function updatePublicApiToken(
  id: string,
  body: PublicApiTokenUpdateBody,
): Promise<PublicApiTokenListItem> {
  const { data } = await authFetch<PublicApiTokenListItem>(`/api-tokens/${id}`, {
    method: "PATCH",
    body: JSON.stringify(body),
  });
  return data;
}

export async function revokePublicApiToken(id: string): Promise<void> {
  await authFetch<{ revoked: boolean }>(`/api-tokens/${id}`, {
    method: "DELETE",
  });
}
